import { ChainId, ERC20Token } from '@pancakeswap/sdk'
import { mantleTestnetTokens } from '@pancakeswap/tokens'
import type { CommonPrice } from '../../src/fetchFarmsV3'

export const CAKE_BNB_LP_MAINNET = '0x0eD7e52944161450477ee417DE9Cd3a859b14fD0'

export type PriceHelper = {
  chain: string
  list: ERC20Token[]
}

export const CHAIN_ID_TO_CHAIN_NAME = {
  [ChainId.MANTLE_TESTNET]: 'mnt_testnet',
  [ChainId.MANTLE]: 'mnt',
} satisfies Record<ChainId, string>

export const priceHelperTokens = {
  // [ChainId.MANTLE]: {
  //   chain: 'bsc',
  //   list: [mantleTokens.wbit, bscTokens.usdt, bscTokens.busd, bscTokens.eth],
  // },
  [ChainId.MANTLE_TESTNET]: {
    chain: 'mnt_testnet',
    list: [mantleTestnetTokens.wbit, mantleTestnetTokens.usdc, mantleTestnetTokens.mama],
  },
} satisfies Record<number, PriceHelper>

// for testing purposes
export const DEFAULT_COMMON_PRICE: Record<ChainId, CommonPrice> = {
  [ChainId.MANTLE]: {},
  [ChainId.MANTLE_TESTNET]: {
    [mantleTestnetTokens.usdc.address]: '1',
  },
}
